"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FullscreenContext = (0, react_1.createContext)(null);
FullscreenContext.displayName = 'FullscreenContext';
exports.default = FullscreenContext;
